import { Button } from "@mui/material";
import { Check, Bookmark, EventAvailable } from "@mui/icons-material";
import { useContext } from "react";
import { toggleRSVP } from "@/services/api";
import { SubscribedContext } from "@/providers/Subscribed";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function RsvpButton({ content, rsvp, onRsvpChange }) {
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async () => {
      toggleRSVP(content);
    },
    onSuccess: () => {
      onRsvpChange(!rsvp);
      queryClient.invalidateQueries({ queryKey: ["experiences"] });
      queryClient.invalidateQueries({ queryKey: ["notes"] });
    },
  });
  const handleRSVP = async () => {
    if (!isSubscribed) {
      handleModalOpen();
      return;
    }
    mutation.mutate();
  };

  if (content.meta.closed) {
    return (
      <Button
        variant="contained"
        color="secondary"
        disabled
        fullWidth
        startIcon={<EventAvailable />}
      >
        Experience Complete
      </Button>
    );
  }

  return (
    <Button
      onClick={handleRSVP}
      variant={rsvp ? "contained" : "outlined"}
      color={rsvp ? "primary" : "secondary"}
      fullWidth
      startIcon={rsvp ? <Check /> : <Bookmark />}
    >
      {rsvp ? "RSVP Confirmed" : "RSVP"}
    </Button>
  );
}
